<template>
  <v-container>
    <v-row>
      <v-col>
        <span class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{plural}}</h1>
          <v-btn class="ml-2" color="info" small fab @click="showCreateMenu"><v-icon>mdi-plus</v-icon></v-btn>
        </span>
        <v-data-table
            :headers="headers"
            :items="allData"
            :items-per-page="-1"
            class="elevation-1"
            :loading="loader"
            @click:row="rowClick"
        >
        </v-data-table>
      </v-col>

      <v-col cols="4" v-if="showSelected && selectedRow">
        <v-card outlined>
          <v-card-title>
            <span>{{singular}} #{{selectedRow.id}} Details</span>
          </v-card-title>
          <v-card-text>
            <span>
              <v-btn small @click="toggleChanges">{{!isEditable?'Edit':'Cancel'}}</v-btn>
            </span>
            <v-form class="mt-5" :disabled="!isEditable" v-model="validUpdate">
              <v-text-field label="Name" v-model="selectedRow.name" outlined/>
              <v-text-field label="Price" type="number" v-model="selectedRow.price" outlined/>
              <v-select
                  :items="alterationTypes"
                  item-text="name"
                  item-value="id"
                  clearable
                  outlined
                  v-model="selectedRow.alterationType"
              />
            </v-form>
          </v-card-text>
          <v-card-actions style="margin-top: -40px;">
            <span class="d-flex flex-column">
              <span class="d-flex flex-row mb-5">
                <v-btn small @click="confirmDeleteDialog=true" color="error" v-if="isEditable" :loading="formLoader">Delete</v-btn>
                <v-btn small @click="updateAlteration" color="success" v-if="isEditable" :disabled="!validUpdate" :loading="formLoader" class="ml-2">Save Changes</v-btn>
              </span>
              <span class="d-flex flex-row">
                <v-btn @click="closeMenu" color="error">Close</v-btn>
              </span>
            </span>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="4" v-if="showAddNew">
        <v-card outlined>
          <v-card-title>
            <span>Add New {{singular}}</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="validCreate">
              <v-text-field outlined type="text" label="Name" v-model="formData.name" :rules="rules.required"/>
              <v-text-field outlined type="number" label="Price" v-model="formData.price" :rules="rules.required"/>
              <v-select
                  :items="alterationTypes"
                  item-text="name"
                  item-value="id"
                  clearable
                  outlined
                  v-model="formData.alterationType"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="create" color="success" :disabled="!validCreate">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="confirmDeleteDialog" max-width="400">
      <v-card class="align-center">
        <v-card-title>
          Delete {{singular}}
        </v-card-title>
        <v-card-text class="pa-5 text-center">
          <span>Are you sure you want to delete this {{singularLower}}?</span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="closeDeleteDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="deleteAlteration" :loading="deleteLoading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import axios from 'axios';
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      isEditable: false,

      snackObj: {
        color: '',
        text: ''
      },

      rules: {
        required: [v => !!v || 'This field is required.'],
      },
      validCreate: false,
      validUpdate: false,

      loader: false,
      headers: [
        { text: 'ID', align: 'start', sortable: true, value: 'id' },
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Price', sortable: true, value: 'price' },
      ],
      allData: [],
      formData: {},

      alterationTypes: [],

      formLoader: false,
      deleteLoading: false,
      confirmDeleteDialog: false,

      selectedRow: null,
      selectedRowData: {
        jobs: [],
        loader: false,
        headers: [
          { text: 'Style No.', align: 'start', sortable: true, value: 'styleNo' },
        ],
      },
      showAddNew: false,
      showSelected: false,

      pluralLower: "alterations",
      plural: "Alterations",
      singularLower: "alteration",
      singular: "Alteration"
    }
  },
  async mounted(){
    await this.getAllData();
  },
  computed: {
    ...mapGetters(['getEndpoint'])
  },
  methods: {
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    async create(){
      try {
        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.formData)
        if(res.data.error) throw res.data.error;

        if(res.data.data.created) this.snack(`${this.singular} Created 🎉`);
        else this.snack(`${this.singular} already exists.`);

        this.formData = {};
        await this.getAllData();
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    async getAllData(){
      try {
        this.loader = true;
        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}`)
        if(res.data.error) throw res.data.error;
        this.allData = res.data.data

        res = await axios.get(`${this.getEndpoint}/api/alterationtypes`)
        if(res.data.error) throw res.data.error;
        this.alterationTypes = res.data.data;

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    async rowClick(row){
      this.selectedRow = row;

      if(!(this.$route.query.selected && this.$route.query.selected==row.id)){
        await this.$router.replace({path: `/${this.pluralLower}`, query: {selected: row.id}})
      }

      this.showAddNew = false;
      this.showSelected = true;
    },
    async showCreateMenu(){
      if(!(this.$route.query.create)){
        await this.$router.replace({path: `/${this.pluralLower}`, query: {create: "true"}})
      }

      this.formData = {};

      this.showSelected = false;
      this.showAddNew = true;
    },
    async closeMenu(){
      this.showSelected = false;
      this.showAddNew = false;
      if(this.$route.query.selected){
        await this.$router.replace({path: `/${this.pluralLower}`, query: null})
      }
      if(this.isEditable) await this.toggleChanges();
    },
    async toggleChanges(){
      if(this.isEditable){
        await this.getAllData();

        if(this.$route.query.selected){
          this.selectedRow = this.allData.find(x => x.id==this.$route.query.selected)
        }
      }
      this.isEditable = !this.isEditable;
    },
    async updateAlteration(){
      try {
        this.formLoader = true;
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.selectedRow.id}`, this.selectedRow)
        if(res.data.error) throw res.data.error;

        this.snack(`${this.singular} Updated 🎉`);
        this.isEditable = false;
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.formLoader = false;
      }
    },
    async deleteAlteration(){
      try {
        this.deleteLoading = true
        let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.selectedRow.id}`)
        if(res.data.error) throw res.data.error
        this.snack(`${this.singular} Deleted 🎉`);

        this.closeDeleteDialog();
        await this.closeMenu();
        await this.getAllData();

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    closeDeleteDialog(){
      this.confirmDeleteDialog = false;
      this.deleteLoading = false;
    },
  }
}
</script>
